import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    if (!this.dialogTarget.open) {
      this.dialogTarget.showModal()
    }
  }

  // The whole modal goes, not just its contents: an emptied controller
  // element would stay in the page, land in Turbo's snapshot cache and, on
  // the next visit to the page, connect without its dialog target.
  close() {
    this.dialogTarget.close()
    this.element.remove()
  }

  submitEnd(event) {
    if (event.detail.success) {
      this.dialogTarget.close()
      visit(window.location.href)
    }
  }
}
